import type { CompetitorFilters, MyBrandFilters, DashboardMode } from "../types/dashboard.types";

export interface MergeExploreHydrationStore {
  competitorFilters: CompetitorFilters;
  myBrandFilters: MyBrandFilters;
}

export interface MergeExploreHydrationResolved {
  mode: DashboardMode;
  competitorFilters: CompetitorFilters;
  myBrandFilters: MyBrandFilters;
}

/** Apply URL-resolved filters for the active mode only; preserve inactive mode from store. */
export function mergeExploreHydrationWithStore(
  store: MergeExploreHydrationStore,
  resolved: MergeExploreHydrationResolved,
): MergeExploreHydrationResolved {
  return {
    mode: resolved.mode,
    competitorFilters:
      resolved.mode === "competitors" ? resolved.competitorFilters : store.competitorFilters,
    myBrandFilters:
      resolved.mode === "my-brand" ? resolved.myBrandFilters : store.myBrandFilters,
  };
}
